// extracted by mini-css-extract-plugin
module.exports = {"empty":"empty--rn54E","lottie":"lottie--rJueC"};